/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/bundles/templates/product.js":
/*!*********************************************!*\
  !*** ./src/js/bundles/templates/product.js ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

eval("/* harmony import */ var _js_utilities_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ~/js/utilities/constants */ \"./src/js/utilities/constants.js\");\n\nconst GIFT_CARD_HANDLES = ['gift-card-250v', 'gift-card'];\nconst getHandleFromURL = () => {\n  const url = window.location.href;\n  const match = url.match(/\\/products\\/([^/?]+)/);\n  return match ? decodeURIComponent(match[1]) : null;\n};\nconst addProductToRecentlyViewed = () => {\n  const handle = getHandleFromURL();\n  if (!handle) return;\n\n  // verify if handle is not gift card\n  if (GIFT_CARD_HANDLES.includes(handle)) return;\n\n  // modify the logic to include the last 10 products in the list\n  let recentlyBrowsedProducts = JSON.parse(window.localStorage.getItem(_js_utilities_constants__WEBPACK_IMPORTED_MODULE_0__.RECENTLY_BROWSED_KEY) || '[]');\n  recentlyBrowsedProducts.unshift(handle);\n  const uniqHandles = new Set(recentlyBrowsedProducts);\n  recentlyBrowsedProducts = [...uniqHandles];\n  // this will ensure we are only tracking the last 10 products\n  recentlyBrowsedProducts = recentlyBrowsedProducts.slice(0, 10);\n  window.localStorage.setItem(_js_utilities_constants__WEBPACK_IMPORTED_MODULE_0__.RECENTLY_BROWSED_KEY, JSON.stringify(recentlyBrowsedProducts));\n};\n\n// Call the function\naddProductToRecentlyViewed();//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///./src/js/bundles/templates/product.js\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	!function() {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = function(result, chunkIds, fn, priority) {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var chunkIds = deferred[i][0];
/******/ 				var fn = deferred[i][1];
/******/ 				var priority = deferred[i][2];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every(function(key) { return __webpack_require__.O[key](chunkIds[j]); })) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"product": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkAnatta_Shopify_Development"] = self["webpackChunkAnatta_Shopify_Development"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["common"], function() { return __webpack_require__("./src/js/bundles/templates/product.js"); })
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;